module.exports = __webpack_public_path__ + "static/img/preview-07.a82db7d3.webp";